app.factory('AuthService', ['ENV', 'localStorageService', 'Session', 'UserService', '$http', '$base64', '$rootScope', 'AUTHENTICATION_STATE', "$timeout", "$httpParamSerializerJQLike", '$q',
	function (ENV, localStorageService, Session, UserService, $http, $base64, $rootScope, AUTHENTICATION_STATE, $timeout, $httpParamSerializerJQLike, $q) {
	
	const isMFAConfigJourney = function (resp){
		return resp.data.mfa_challenge === "MFA_SETUP";
	}

	const isMFAVerifyJourney = function (resp){
		return resp.data.mfa_challenge === "SOFTWARE_TOKEN_MFA";
	}

	function requestWithOptionalEmptyBody(config) {
		return $http(angular.extend({
			responseType: 'text',
			transformResponse: [function (data) {
				return data || null;
			}],
		}, config)).catch(function () {
			return { data: null, status: 204 };
		});
	}

	var service = {
		'isProcessing': false,
		'authorize': function () {
			return $http({
				method: "GET",
				url: ENV.API + "/login",
				headers: {
					"Accept": "application/json"
				},
				withCredentials: true
			}).then(function (response) {
				return response.data._csrf;
			});
		},
		'login': function(creds, csrfToken, callback) {
			service.isProcessing = true;

			var formData = {
				username: creds.username,
				password: creds.password,
				_csrf: csrfToken
			};

			return $http({
				method: 'POST',
				url: ENV.API + '/login',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				data: $httpParamSerializerJQLike(formData),
				withCredentials: true
			}).then(function (resp) {
				if (isMFAConfigJourney(resp)) {
					// PRIORITIZE MFA SETUP: Check for MFA configuration first.
					callback(creds, {
						authenticationState: AUTHENTICATION_STATE.configMFA,
						mfa_challenge: resp.data.mfa_challenge,
						updatePasswordRequired: resp.data.update_password_required,
						userName: resp.data.user_name,
					});
				} else if (isMFAVerifyJourney(resp)) {
					// Wait for MFA code validation.
					callback(creds, {
						authenticationState: AUTHENTICATION_STATE.waitingMFACode,
						mfa_challenge: resp.data.mfa_challenge,
						updatePasswordRequired: resp.data.update_password_required,
						userName: resp.data.userName
					});
				} 
			},function(err) {
				// $q, not a native Promise: a native one settles outside the digest, so the caller's
				// error message and spinner reset would not render until something else digested.
				return $q.reject('error logging in');
			}).finally(function() {
				// finally, not then: a failed login skipped the reset and left the overlay up.
				service.isProcessing = false;
			})
		},
		// Signs out this tab's sign-in only; a tab signed in as someone else carries on. The tab then waits at
		// the login page rather than continuing another tab's sign-in.
		'logout': function () {
			if (!Session.token) {
				Session.endSignIn();
				return $q.resolve({ data: null, status: 204 });
			}
			const request = requestWithOptionalEmptyBody({
				method: "POST",
				url: ENV.API + "/api/security/logout",
				headers: Session.signInHeaders({
					Authorization: "Bearer " + Session.token,
					Accept: "text/plain, */*",
				}),
			});
			Session.endSignIn();
			return request;
		},
		'isAuthenticated': function () {
			return !!Session.userId;
		},

		'getPasswordResetToken': function(email) {
			service.isProcessing = true;
			return $http({
				method: 'POST',
				url: ENV.API + '/api/security/getPasswordResetToken',
				data: {
					email: email
				}
			}).then(function(resp) {
				service.isProcessing = false;
				return resp;
			},function(err) {
				service.isProcessing = false;
				return $q.reject('error sending request');
			})
		},

		'validatePasswordToken': function(token) {
			service.isProcessing = true;
			return $http({
				method: 'POST',
				url: ENV.API + '/api/security/validateToken',
				data: {
					token: token
				}
			}).then(function(resp) {
				service.isProcessing = false;
			},function(err) {
				service.isProcessing = false;
				return $q.reject('error sending request');
			})
		},

		'resetPassword': function(token, newPassword, username) {
			service.isProcessing = true;
			return $http({
				method: 'POST',
				url: ENV.API + '/api/security/resetPassword',
				data: {
					username: username,
					token: token,
					newPassword: newPassword
				}
			}).then(function(resp) {
				service.isProcessing = false;
			},function(err) {
				service.isProcessing = false;
				return $q.reject('error sending request');
			})
		},
		'verifyMfaCode': function(creds, csrfToken, mfa_code) {
			var authString = 'Basic ' +  $base64.encode(creds.username + ':' + creds.password);
			return $http({
				method: 'POST',
				url: ENV.API + '/mfa?_csrf=' + csrfToken,
				headers: {'Authorization': authString},
				data: {
					'mfa_challenge': "SOFTWARE_TOKEN_MFA",
    				'mfa_code': mfa_code
				},
				withCredentials: true
			})
            
		},
		'exchangeForTokens': function (keepLoggedIn) {
			Session.startSignIn();
			return $http({
				method: 'GET',
				url: ENV.API + '/oauth2/token/exchange?keepLoggedIn=' + keepLoggedIn,
				withCredentials: true,
				headers: Session.signInHeaders({}),
			});
		},
		'refreshAccessToken': function () {
			return $http({
				method: 'POST',
				url: ENV.API + '/refresh-token',
				withCredentials: true,
				responseType: 'text',
				headers: Session.signInHeaders({
					Accept: 'application/json, text/plain, */*',
				}),
				transformResponse: [function (data) {
					if (!data) {
						return {};
					}
					try {
						return JSON.parse(data);
					} catch (e) {
						return data;
					}
				}],
			}).then(function (resp) {
				Session.continueSignIn(resp);
				return resp;
			});
		},
		'initialMfa': function (csrfToken) {
			return $http({
				method: 'POST',
				url: ENV.API + '/mfa/init?_csrf=' + csrfToken
			})
		},
		'completeMfa': function (mfa_code, csrfToken) {
			return $http({
				method: 'POST',
				url: ENV.API + '/mfa/verify?_csrf=' + csrfToken,
				data: {
					'mfa_challenge': "SOFTWARE_TOKEN_MFA",
    				'mfa_code': mfa_code
				}
			})
		},
		'updateEmail': function (newEmail) {
			return $http({
				method: 'POST',
				url: ENV.API + '/api/security/changeEmail',
				headers: {
					Authorization: "Bearer " + Session.token,
				},
				data: {
					'new_email': newEmail
				}
			})
		},
		'verifyEmail': function (token) {
			return $http({
				method: 'POST',
				url: ENV.API + '/api/security/verifyEmail',
				headers: {
					Authorization: "Bearer " + Session.token,
				},
				data: {
					'token': token
				}
			})
		}
	};
	 
	return service;
}])